<template>
    <div id="container" class="center">
        <div class="box center" style="background-color: rgb(214, 214, 214);">
            <router-link to="/apprendre">
                <v-btn type="submit" class="routerBtn" style="background-color: aliceblue;">Apprendre</v-btn>
            </router-link>
        </div>
        <div class="box center">
            <router-link to="/quizz">
                <v-btn type="submit" class="routerBtn" style="background-color: rgb(214, 214, 214);">Quizz</v-btn>
            </router-link>
        </div>
    </div>
</template>

<script>

export default {
    name: 'HomePage',
    components: {
    },
    data() {
        return {

        }
    },
    mounted() {
    },
    methods: {

    }
}
</script>

<style scoped>
#container {
    margin: 0px;
    padding: 0px;
    width: 100%;
    height: 100%;
}

.center {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
}

.routerBtn {
    width: 130px;
    height: 50px;
}

.box {
    width: 50vw;
    height: 100vh;
    background-color: aliceblue;
    justify-content: space-evenly;
}
</style>
